import { useState } from 'react';
import { useStoreContext } from '../../../components/Context';
import { createAsyncActions } from './actions';
import { getAsyncState } from './selectors';
export var createAsyncState = function (key) {
    var _a = createAsyncActions(key), start = _a.start, success = _a.success, error = _a.error, reset = _a.reset;
    var getState = getAsyncState(key);
    return function useAsyncState(idx) {
        var _a = useStoreContext(), state = _a[0], dispatch = _a[1];
        var actions = useState({
            reset: function () { return dispatch(reset(idx)); },
            start: function () { return dispatch(start(idx)); },
            success: function (d, m) { return dispatch(success(d, m, idx)); },
            error: function (e) { return dispatch(error(e, idx)); },
        })[0];
        return [getState(state, idx), actions];
    };
};
